import BigNumber from 'bignumber.js';

class BigNumberUtil {
  toNumber(bigNumber, decimalPlaces, formatDecimals = 0) {
    const decimal = new BigNumber(10).pow(new BigNumber(decimalPlaces - formatDecimals));
    let value = new BigNumber(bigNumber).div(decimal).toNumber(); ///
    if (formatDecimals > 0) {
      value /= 10 ** formatDecimals;
    }
    return value;
  }

  toBig(number, decimalPlaces) {
    const value = new BigNumber(number).multipliedBy(new BigNumber(10).pow(decimalPlaces));

    return value;
  }
}
export default new BigNumberUtil();
